import { render, staticRenderFns } from "./LessonGlossaryDialog.vue?vue&type=template&id=7562faf0&"
import script from "./LessonGlossaryDialog.vue?vue&type=script&lang=ts&"
export * from "./LessonGlossaryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports